'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.USER_DATA_KEY = undefined;

var _lodash = require('lodash.assign');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isfunction');

var _lodash4 = _interopRequireDefault(_lodash3);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _Authenticator = require('./Authenticator');

var _Authenticator2 = _interopRequireDefault(_Authenticator);

var _WebStorage = require('./WebStorage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_DATA_KEY = exports.USER_DATA_KEY = '__userData'; /* eslint-disable no-console */

var STORAGE_TYPE = 'sessionStorage';

var USER_DATA_BASE_URL = 'https://broadband.espn.com/espn3/auth/watchespn/user';

function IpAuthenticator(_ref) {
    var _ref$partner = _ref.partner,
        partner = _ref$partner === undefined ? 'watchespn' : _ref$partner,
        _ref$platform = _ref.platform,
        platform = _ref$platform === undefined ? 'web' : _ref$platform,
        _ref$userDataServiceU = _ref.userDataServiceUrl,
        userDataServiceUrl = _ref$userDataServiceU === undefined ? USER_DATA_BASE_URL : _ref$userDataServiceU;

    if (!(this instanceof IpAuthenticator)) {
        return new IpAuthenticator({ partner: partner, platform: platform, userDataServiceUrl: userDataServiceUrl });
    }
    var userDataUrl = userDataServiceUrl + '?partner=' + partner + '&platform=' + platform;
    var _isAuthenticated = false;
    var userDataPromise = void 0;
    var ispAuthInfo = void 0;

    function getUserData() {
        var userData = (0, _WebStorage.getJson)(USER_DATA_KEY, STORAGE_TYPE);
        if (userData !== null) {
            userDataPromise = Promise.resolve(userData);
        } else if (!userDataPromise) {
            userDataPromise = new Promise(function (resolve, reject) {
                _superagent2.default.get(userDataUrl).end(function (err, res) {
                    if (res) {
                        var userDataResponse = JSON.parse(res.text);
                        (0, _WebStorage.setJson)(USER_DATA_KEY, userDataResponse, STORAGE_TYPE);
                        resolve(userDataResponse);
                    } else {
                        reject(err || new Error('Unknown error'));
                    }
                });
            }).catch(function (err) {
                console.log('Error getting UserData: ', err);
                userDataPromise = null;
                return undefined;
            });
        }
        return userDataPromise;
    }

    function checkIpAuth() {
        return getUserData().then(function (userData) {
            ispAuthInfo = userData && userData.user && userData.user.authentication && userData.user.authentication.isp;
            _isAuthenticated = ispAuthInfo !== undefined && ispAuthInfo.name !== 'espn';
            return _isAuthenticated;
        });
    }
    (0, _lodash2.default)(this, _Authenticator2.default);

    return (0, _lodash2.default)(this, {
        initialize: function initialize(callback) {
            return checkIpAuth().then(function () {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, true);
                }
                return true;
            });
        },
        isAuthenticated: function isAuthenticated() {
            return _isAuthenticated;
        },
        checkAuthentication: function checkAuthentication(callback) {
            return checkIpAuth().then(function (isAuthenticated) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, isAuthenticated);
                }
                return isAuthenticated;
            });
        },
        authenticate: function authenticate(identity, callback) {
            return checkIpAuth().then(function (isAuthenticated) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, isAuthenticated);
                }
                return isAuthenticated;
            });
        },
        deauthenticate: function deauthenticate(callback) {
            _isAuthenticated = false;
            return Promise.resolve(_isAuthenticated).then(function (isAuthenticated) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, isAuthenticated);
                }
                return isAuthenticated;
            });
        },
        getAuthenticationInfo: function getAuthenticationInfo(callback) {
            return getUserData().then(function (userData) {
                var authenticationInfo = userData && userData.user && userData.user.authentication && userData.user.authentication.isp;
                var mvpd = authenticationInfo.name,
                    imgUrl = authenticationInfo.imageHref;

                var authInfo = mvpd !== 'espn' ? { mvpd: mvpd, imgUrl: imgUrl } : null;
                if ((0, _lodash4.default)(callback)) {
                    callback(null, authInfo);
                }
                return authInfo;
            });
        },
        getLocation: function getLocation(callback) {
            return getUserData().then(function (userData) {
                return userData && userData.user && userData.user.location;
            }).then(function (location) {
                if ((0, _lodash4.default)(callback)) {
                    callback(null, location);
                }
                return location;
            });
        }
    });
}

exports.default = IpAuthenticator;


//////////////////
// WEBPACK FOOTER
// ./node_modules/watch-authenticators/build/IpAuthenticator.js
// module id = 666
// module chunks = 1